// extracted by mini-css-extract-plugin
module.exports = {"toast-border":"Toast_toast-border__3yvd8"};